module.exports = __webpack_public_path__ + "img/background_c3-2-1.ea42e568.jpg";